// extracted by mini-css-extract-plugin
export default {"iframe":"iframe_iframe__93f89","fullScreen":"iframe_fullScreen__72c7c"};